import { Link } from "react-router-dom";
import type { Article } from "@/types/content";

export default function ArticleCard({
  article,
  variant = "default",
}: {
  article: Article;
  variant?: "default" | "compact";
}) {
  const to = `/articles/${article.id}`;

  if (variant === "compact") {
    return (
      <Link
        to={to}
        className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300"
      >
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700">
          <i className="ri-article-line text-xl"></i>
        </span>
        <span className="min-w-0">
          <span className="flex flex-wrap items-center gap-2 text-[11px] text-foreground-500">
            <span className="whitespace-nowrap rounded bg-secondary-100 px-1.5 py-0.5 text-secondary-900">
              {article.category}
            </span>
            <span className="whitespace-nowrap">{article.readingTime}</span>
          </span>
          <span className="mt-1.5 block font-heading text-sm font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
            {article.title}
          </span>
        </span>
      </Link>
    );
  }

  return (
    <Link
      to={to}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="h-44 w-full overflow-hidden bg-background-200 md:h-48">
        <img
          src={article.cover}
          alt={`${article.title} 配图`}
          title={`${article.title}｜511爆料求证笔记`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <div className="flex flex-wrap items-center gap-2 text-[11px] text-foreground-500">
          <span className="whitespace-nowrap rounded bg-accent-100 px-2 py-0.5 font-medium text-accent-900">
            {article.category}
          </span>
          <span className="whitespace-nowrap">{article.readingTime}</span>
          <span className="whitespace-nowrap">{article.date}</span>
        </div>
        <h3 className="mt-3 font-heading text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
          {article.title}
        </h3>
        <p className="mt-2 line-clamp-3 text-sm leading-relaxed text-foreground-600">
          {article.excerpt}
        </p>
        <span className="mt-4 inline-flex items-center gap-1 whitespace-nowrap text-xs font-medium text-primary-700">
          阅读求证笔记
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-arrow-right-line text-base"></i>
          </span>
        </span>
      </div>
    </Link>
  );
}